import type { ReactNode } from "react";
import {
	Table,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/catalyst/Table";
import { Fab } from "@/components/Fab";

interface PartnersLayoutProps {
	children: ReactNode;
	onCreateClick: () => void;
	isEmpty?: boolean;
	emptyState?: ReactNode;
}

export function PartnersLayout({
	children,
	onCreateClick,
	isEmpty,
	emptyState,
}: PartnersLayoutProps) {
	return (
		<div className="mt-8">
			{isEmpty && emptyState ? (
				emptyState
			) : (
				<Table>
					<TableHead>
						<TableRow>
							<TableHeader>Partner Name</TableHeader>
							<TableHeader>Email</TableHeader>
							<TableHeader>Status</TableHeader>
							<TableHeader>Stripe</TableHeader>
							<TableHeader>App</TableHeader>
							<TableHeader>Created</TableHeader>
							<TableHeader></TableHeader>
						</TableRow>
					</TableHead>
					{children}
				</Table>
			)}
			<Fab label="Create Partner" onClick={onCreateClick} />
		</div>
	);
}
